import { makeWithContextProviderHOC } from "@contexts/utils";
import type React from "react";
import { createContext, useState } from "react";

interface LightboxContextType {
	lightboxContext: any;
	setlightboxContext: React.Dispatch<any>;
	removeLightboxContext: () => void;
}

const LightboxContext = createContext<LightboxContextType | null>(null);

const defaultLightboxContext = null;

interface LightboxContextProviderProps {
	children: React.ReactNode;
	lightboxContext?: any;
}

export const LightboxContextProvider = ({
	children,
	lightboxContext,
}: LightboxContextProviderProps) => {
	const [currentlightboxContext, setlightboxContext] = useState(
		lightboxContext || defaultLightboxContext,
	);

	const removeLightboxContext = () =>
		setlightboxContext(defaultLightboxContext);

	return (
		<LightboxContext.Provider
			value={{
				lightboxContext: currentlightboxContext,
				setlightboxContext,
				removeLightboxContext,
			}}
		>
			{children}
		</LightboxContext.Provider>
	);
};
export const withLightboxContextProvider = makeWithContextProviderHOC(
	LightboxContextProvider,
);

export const LightboxContextConsumer = LightboxContext.Consumer;

export default LightboxContext;
